import type { FixedDatesTimeLimit, TimeLimitHandler } from './types';
import { fromUTCtoLocalTime } from './TimeLimitUtils';

export class FixedDatesTimeHandler implements TimeLimitHandler {
  constructor(private readonly config: FixedDatesTimeLimit) {}

  public canStart(): boolean {
    return this.getStartDate() >= Date.now() && Date.now() < this.getEndDate() - (this.config.cutOffPoint ?? 0);
  }

  public getEndDate(): number {
    return this.config.toLocalTime ? fromUTCtoLocalTime(this.config.endDate) : this.config.endDate;
  }

  public getStartDate(): number {
    return this.config.toLocalTime ? fromUTCtoLocalTime(this.config.startDate) : this.config.startDate;
  }

  public hasEnded(): boolean {
    return Date.now() >= this.getEndDate();
  }
}
